import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Icon from '@material-ui/core/Icon'
import PropTypes from 'prop-types'
import Colors from '~shared/assets/styles/colors'
import resolveFieldLinkHref from './resolveFieldLinkHref'

const styles = theme => ({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
    padding: `1px ${theme.spacing.unit * 0.75}px`,
    borderRadius: 4,
    backgroundColor: Colors['Aqua010'],
    color: Colors.TextBrand,
    fontWeight: 500,
    lineHeight: 1.6,
    textDecoration: 'none',
    verticalAlign: 'middle',
    '&:hover': {
      backgroundColor: Colors['Aqua020'],
      textDecoration: 'none',
    },
  },
  icon: {
    flexShrink: 0,
    fontSize: 16,
    marginRight: 4,
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const stopPropagation = e => {
  e.stopPropagation()
}

const FieldValueLink = ({ classes, linkTemplate, value }) => {
  const linkHref = resolveFieldLinkHref(linkTemplate, value)

  if (!linkHref) return value

  return (
    <a
      className={classes.link}
      href={linkHref}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
    >
      <Icon className={classes.icon}>open_in_new</Icon>
      <span className={classes.text}>{value}</span>
    </a>
  )
}

FieldValueLink.propTypes = {
  classes: PropTypes.object.isRequired,
  linkTemplate: PropTypes.string,
  value: PropTypes.any,
}

export default withStyles(styles)(FieldValueLink)
